import { withInstall } from "../utils";
import _ActionBar from "./ActionBar";
const ActionBar = withInstall(_ActionBar);
var stdin_default = ActionBar;
export {
  ActionBar,
  stdin_default as default
};
